
export default function Unauthorized() {

  return (
    <div className="p-6">
      <h1 className="text-white">Usuario no autorizado</h1>
    </div>
  );
}
